import _helpers from '@toasttab/shared/src/globals/_helpers'
import { KeyValuePair } from '@toasttab/shared/src/interfaces/Interface.d'

export const storeCurrentPageNonDemo = () => {
  if (typeof window !== 'undefined') {
    const currentPagePath = window.location.pathname
    const bIsDemo =
      currentPagePath.includes('/request-demo') ||
      currentPagePath.includes('/quote-request')
    if (!bIsDemo) {
      _helpers.createCookie('last_path_not_demo', currentPagePath, 1440, '/')
    }
  }
}

export const parseUtmParametersPromise = () => {
  return new Promise((resolve: any) => {
    const currentUrl = window.location.href
    let queryString = currentUrl
      ? currentUrl.split('?')[1]
      : window.location.search.slice(1)
    if (queryString) {
      queryString = queryString.split('#')[0]
      const arr = queryString.split('&')
      for (let i = 0; i < arr.length; i++) {
        const a = arr[i].split('=')
        const paramName = a[0]
        const paramValue: any = typeof a[1] === 'undefined' ? true : a[1]
        const qualifiers = [
          'utm_campaign',
          'utm_source',
          'utm_medium',
          'utm_term',
          'source',
          'gclid'
        ]
        if (qualifiers.indexOf(paramName) > -1) {
          _helpers.createCookie(paramName, paramValue, 1440, '/')
        }

        // console.log(arr.length)
        // if you have gone through all of the utms and created cookies then map them to hidden form fields
        if (i === arr.length - 1) {
          resolve()
        }
      }
    } else {
      resolve()
    }
  })
}

export const getInitialFormValues = (
  initialValues: KeyValuePair,
  utmParameters: KeyValuePair = {},
  extraInitialValues: KeyValuePair = {}
) => {
  storeCurrentPageNonDemo() // Could probably delete now that storeCurrentPageNonDemo is called in parseUtmParametersPromise but would want to test OTL first

  const campaignValue = utmParameters.utm_campaign
    ? utmParameters.utm_campaign
    : _helpers.getCookie('utm_campaign')
  const utmSourceValue = utmParameters.utm_source
    ? utmParameters.utm_source
    : _helpers.getCookie('utm_source')
  const utmMediumValue = utmParameters.utm_medium
    ? utmParameters.utm_medium
    : _helpers.getCookie('utm_medium')
  const utmTermValue = utmParameters.utm_term
    ? utmParameters.utm_term
    : _helpers.getCookie('utm_term')
  const sourceValue = utmParameters.source
    ? utmParameters.source
    : _helpers.getCookie('source')
  const lastPageNotDemo = _helpers.getCookie('last_path_not_demo')
  const gclid = utmParameters.gclid
    ? utmParameters.gclid
    : _helpers.getCookie('gclid')
  const fN = _helpers.getCookie('fN')
  const comp = _helpers.getCookie('company')
  const lN = _helpers.getCookie('lN')
  const fullName = _helpers.getCookie('fullName')
  const email = _helpers.getCookie('email')
  const phone = _helpers.getCookie('phonenumber')
  const currentContentCookie = _helpers.getCookie('contentViewed')
  let lastBlogSeen
  const _lastBlogSeen = _helpers.getCookie('Last_Blog_Seen__c')
  if (_lastBlogSeen) {
    lastBlogSeen = `/blog/${_lastBlogSeen}`
  }

  const progressiveCookie = _helpers.getCookie('progressiveEnabled')

  const values: KeyValuePair = {
    ...initialValues,
    Web_initiative__c: campaignValue,
    Web_origin__c: utmSourceValue + '|' + utmMediumValue,
    Web_detail__c: utmTermValue,
    Website_Source_Detail__c: sourceValue,
    Last_Blog_Seen__c: lastBlogSeen,
    pageFormSubmissionURL: lastPageNotDemo,
    GCLID__c: gclid,
    firstName: fN,
    lastName: lN,
    company: comp,
    mkoFullName: fullName,
    email: email,
    phone: phone,
    eI: currentContentCookie,
    progressiveEligible: progressiveCookie ? 'yes' : 'no',
    ...extraInitialValues
  }

  return {
    initialValues: values
  }
}

export const initDataCapture = () => {
  storeCurrentPageNonDemo()
  parseUtmParametersPromise()
}
